module.exports = __webpack_public_path__ + "media/images/icons/outlined/folder-view-8412977619cc969a227c827c752b0540.svg";